import { render, staticRenderFns } from "./UserPackageDatasets.vue?vue&type=template&id=7761825b"
import script from "./UserPackageDatasets.vue?vue&type=script&lang=js"
export * from "./UserPackageDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports